import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Checkbox,
  Button,
  Stack,
  Snackbar,
  Alert,
  Paper,
} from "@mui/material";
import api from "../../api/axios";

const ArchivedProducts = () => {
  const [products, setProducts] = useState([]);
  const [selected, setSelected] = useState([]);
  const [undoData, setUndoData] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  /* ================= FETCH ================= */
  const fetchArchived = async () => {
    try {
      const { data } = await api.get("/products/archived");
      setProducts(data.products);
    } catch (err) {
      console.error("Fetch archived failed:", err);
    }
  };

  useEffect(() => {
    fetchArchived();
  }, []);

  /* ================= SELECT ================= */
  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id)
        ? prev.filter((i) => i !== id)
        : [...prev, id]
    );
  };

  const isAllSelected =
    products.length > 0 && selected.length === products.length;

  const toggleSelectAll = () => {
    if (isAllSelected) {
      setSelected([]);
    } else {
      setSelected(products.map((p) => p._id));
    }
  };

  /* ================= ACTIONS ================= */
  const handleRestore = async (id) => {
    await api.patch(`/products/${id}/restore`);

    setUndoData({ ids: [id] });
    setSnackbarOpen(true);

    fetchArchived();
  };

  const handleBulkRestore = async () => {
    if (!selected.length) return;

    await api.patch("/products/bulk/restore", {
      ids: selected,
    });

    setUndoData({ ids: selected });
    setSelected([]);
    setSnackbarOpen(true);

    fetchArchived();
  };

  const handleUndo = async () => {
    if (!undoData) return;

    await api.patch("/products/bulk/archive", {
      ids: undoData.ids,
    });

    setSnackbarOpen(false);
    fetchArchived();
  };

  /* ================= UI ================= */
  return (
    <Box p={3}>
      <Typography variant="h5" fontWeight={700} mb={2}>
        Archived Products
      </Typography>

      {/* 🔹 Bulk Actions */}
      <Stack direction="row" spacing={2} mb={2}>
        <Checkbox
          checked={isAllSelected}
          indeterminate={
            selected.length > 0 && selected.length < products.length
          }
          onChange={toggleSelectAll}
        />

        <Button
          variant="contained"
          disabled={!selected.length}
          onClick={handleBulkRestore}
        >
          Restore Selected
        </Button>
      </Stack>

      {/* 🔹 Product List */}
      <Stack spacing={2}>
        {products.map((p) => (
          <Paper
            key={p._id}
            sx={{
              p: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Stack direction="row" spacing={2} alignItems="center">
              <Checkbox
                checked={selected.includes(p._id)}
                onChange={() => toggleSelect(p._id)}
              />

              <Typography>{p.title}</Typography>
            </Stack>

            <Button
              variant="outlined"
              onClick={() => handleRestore(p._id)}
            >
              Restore
            </Button>
          </Paper>
        ))}
      </Stack>

      {/* 🔹 Undo Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          severity="success"
          action={
            <Button color="inherit" size="small" onClick={handleUndo}>
              UNDO
            </Button>
          }
        >
          Products restored
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ArchivedProducts;